import { createFeature, createReducer, on } from '@ngrx/store';
import { CreditAccount } from '@enrollhere/classes';
import { AccountActions } from './account.actions';

export const accountFeatureKey = 'account';

export interface AccountState {
  accounts: CreditAccount[];
  account: CreditAccount | null;
  loading: boolean;
  error: Error | null;
}

const initialState: AccountState = {
  accounts: [],
  account: null,
  loading: false,
  error: null,
};

export const accountInitialState: AccountState = initialState;

const reducer = createReducer(
  initialState,
  on(
    AccountActions.loadAccounts,
    (state): AccountState => ({
      ...state,
      loading: true,
      error: null,
    })
  ),
  on(
    AccountActions.loadAccountsSuccess,
    (state, { accounts }): AccountState => ({
      ...state,
      accounts: [
        ...state.accounts.filter(item => !accounts.find(x => x.id === item.id)),
        ...accounts,
      ],
      loading: false,
      error: null,
    })
  ),
  on(
    AccountActions.loadAccountsFailure,
    (state, { error }): AccountState => ({
      ...state,
      loading: false,
      error,
    })
  ),
  on(
    AccountActions.loadAccount,
    (state): AccountState => ({
      ...state,
      loading: true,
      error: null,
    })
  ),
  on(
    AccountActions.loadAccountSuccess,
    (state, { account }): AccountState => ({
      ...state,
      accounts: [
        ...state.accounts.filter(item => account.id !== item.id),
        account,
      ],
      account: account,
      loading: false,
      error: null,
    })
  ),
  on(
    AccountActions.loadAccountFailure,
    (state, { error }): AccountState => ({
      ...state,
      loading: false,
      error,
    })
  ),
  on(
    AccountActions.addAccount,
    (state): AccountState => ({
      ...state,
      loading: true,
      error: null,
    })
  ),
  on(
    AccountActions.addAccountSuccess,
    (state, { account }): AccountState => ({
      ...state,

      accounts: [...state.accounts, account],

      loading: false,

      error: null,
    })
  ),
  on(
    AccountActions.addAccountFailure,
    (state, { error }): AccountState => ({
      ...state,
      loading: false,
      error,
    })
  ),
  on(
    AccountActions.removeAccount,
    (state): AccountState => ({
      ...state,
      loading: true,
      error: null,
    })
  ),
  on(
    AccountActions.removeAccountSuccess,
    (state, { accountId }): AccountState => ({
      ...state,
      accounts: state.accounts.filter(account => account.id !== accountId),
      loading: false,
      error: null,
    })
  ),
  on(
    AccountActions.removeAccountFailure,
    (state, { error }): AccountState => ({
      ...state,
      loading: false,
      error,
    })
  ),
  on(
    AccountActions.updateAccount,
    (state): AccountState => ({
      ...state,
      loading: true,
      error: null,
    })
  ),
  on(
    AccountActions.updateAccountSuccess,
    (state, { account }): AccountState => ({
      ...state,
      accounts: state.accounts.map(item =>
        // item.id === account.id ? account : item
        item.id === account.id ? { ...item, ...account } : item
      ),
      loading: false,
      error: null,
    })
  ),
  on(
    AccountActions.updateAccountFailure,
    (state, { error }): AccountState => ({
      ...state,
      loading: false,
      error,
    })
  )
);

export const accountReducer = reducer;

export const accountFeature = createFeature({
  name: accountFeatureKey,
  reducer,
});
